<div class="vd-page app-album-list" [ngStyle]="themeVars">
    <ng-container *ngIf="is_can_see_album; else notAvailable">
        <div class="vd-backdrop" aria-hidden="true"><div class="vd-backdrop-img"><app-vd-thumb [info]="heroPictureInfo" [eager]="true"></app-vd-thumb></div></div>
        <div class="vd-container">
            <button type="button" class="vd-back" (click)="goToGener()"><app-vd-icon name="back"></app-vd-icon> Back</button>
            <ng-container *ngIf="isLoaded; else loading">

            <section class="vd-stage" [class.is-theatre]="theatre" [class.is-playing]="!!inline.payload">
                <div class="vd-main">
                    <div class="vd-screen">
                        <app-vd-player *ngIf="inline.payload" [payload]="inline.payload" [theatre]="theatre"
                            (ready)="inlinePlayer = $event" (ended)="onPlayerEnded()" (playState)="inline.state = $event" (theatreToggle)="theatre = !theatre"></app-vd-player>
                        <button type="button" class="vd-poster" *ngIf="!inline.payload" [disabled]="!actions.showPlay || actions.playDisabled || !!inline.pendingId" [attr.aria-busy]="!!inline.pendingId" (click)="onHeroPlay()" (pointerenter)="warmPlayer()" (focus)="warmPlayer()"
                            [attr.aria-label]="'Play ' + (streamInfo.stream_video_title || 'video')">
                            <app-vd-thumb [info]="heroPictureInfo" [eager]="true" [fallback]="video_banner_image"></app-vd-thumb>
                            <span class="vd-poster-play" *ngIf="actions.showPlay && !actions.playDisabled">
                                <span class="vd-spinner" *ngIf="inline.pendingId; else posterPlayIcon" role="status" aria-label="Starting video"></span>
                                <ng-template #posterPlayIcon><app-vd-icon name="play"></app-vd-icon></ng-template>
                            </span>
                        </button>
                        <div class="vd-upnext" *ngIf="inline.upNext" role="status">
                            <span>Up next in {{ inline.upNextSeconds }} · <strong>{{ inline.upNext.stream_info?.stage }}</strong></span>
                            <button type="button" class="vd-btn vd-btn-accent" (click)="inline.playUpNext()">Play now</button>
                            <button type="button" class="vd-btn vd-btn-ghost" (click)="inline.cancelUpNext()">Cancel</button>
                        </div>
                    </div>
                    <!-- Album details sit above the video list on the right; only an album without videos (no list) keeps them here. -->
                    <ng-container *ngIf="!videos.length"><ng-container *ngTemplateOutlet="albumInfo"></ng-container></ng-container>
                </div>
                <div class="vd-side" *ngIf="videos.length">
                    <div class="vd-side-info"><ng-container *ngTemplateOutlet="albumInfo"></ng-container></div>
                    <app-vd-side-panel [tab]="panelTab" (tabChange)="panelTabChoice = $event"
                        [showComments]="commentsEnabled" [commentCount]="(inlinePlayer ? inlinePlayer.comments?.length : commentsFeed.comments.length) || 0">
                        <div panelNext>
                            <ng-container *ngIf="{ video: nextVideo } as up"><app-vd-video-row *ngFor="let element of videos; let i = index; trackBy: trackByVideo" [next]="up.video === element" [compact]="true" [playing]="isNowPlaying(element)" [playState]="inline.state" [starting]="!!inline.pendingId && inline.pendingId === element.stream_info?.id"
                                [element]="element" [index]="i" [access]="rowAccess(element)" [fallbackImage]="video_banner_image"
                                [settingsData]="settingsData" [playListAry]="playListAry" [tickets]="tickets" [isPreview]="isPreviewUrl"
                                (play)="onRowPlay($event)" (togglePlay)="inlinePlayer?.onVideoClick()" (buy)="openVideoAudioPayment($event)" (subscribe)="doSubscribePayment($event, true)"
                                (like)="onRowLike($event.element, $event.index)" (share)="openShare($event.element, $event.anchor)"
                                (report)="reportFileData($event, 'uploadedVideo')"
                                (createPlaylist)="createPlayList('video')" (addToPlaylist)="addToPlayList($event.element, $event.playList)">
                            </app-vd-video-row></ng-container>
                        </div>
                        <app-vd-comments panelComments [player]="inlinePlayer" [feed]="commentsFeed" (loginRequired)="requireLogin()"></app-vd-comments>
                    </app-vd-side-panel>
                </div>
                <app-vd-recs *ngIf="recs.cards.length" [title]="recs.title" [cards]="recs.cards"
                    (open)="recs.open($event, channelName, isPreviewUrl, activatedRoute.snapshot.queryParams.token)"></app-vd-recs>
            </section>

            <!-- Ad slots: same bindings as the classic page -->
            <div class="text-right ad-right-learn-more" *ngIf="showAdright">
                <div class="d-inline-block relative">
                    <div [innerHTML]="adVideoright" class="adright text-center"></div>
                    <span class="icon-bg mr-2 left-top">
                        <a *ngIf="!isPreviewUrl" [href]="selectedAdRightData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <app-vd-icon name="external"></app-vd-icon></a>
                        <a *ngIf="isPreviewUrl" class="mr-2 text-white text-decoration-none slick-disabled">Learn more <app-vd-icon name="external"></app-vd-icon></a>
                    </span>
                </div>
            </div>
            <div class="text-center p-20 w-100" *ngIf="showAdCenter">
                <div class="d-inline-block relative">
                    <div [innerHTML]="adVideoCenter" class="adcenter text-center"></div>
                    <span class="icon-bg mr-2 left-top">
                        <a *ngIf="!isPreviewUrl" [href]="selectedAdCenterData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <app-vd-icon name="external"></app-vd-icon></a>
                        <a *ngIf="isPreviewUrl" class="mr-2 text-white text-decoration-none slick-disabled">Learn more <app-vd-icon name="external"></app-vd-icon></a>
                    </span>
                </div>
            </div>
            </ng-container>
            <ng-template #loading>
                <div class="vd-stage" aria-busy="true" aria-label="Loading">
                    <div class="vd-main"><div class="vd-skel vd-skel-poster"></div><div class="vd-skel vd-skel-line is-wide"></div><div class="vd-skel vd-skel-line"></div><div class="vd-skel vd-skel-btn"></div></div>
                    <div><div class="vd-skel vd-skel-row"></div><div class="vd-skel vd-skel-row"></div><div class="vd-skel vd-skel-row"></div></div>
                </div>
            </ng-template>
        </div>

        <!-- Side panels: unchanged from the classic page -->
        <div class="rightsidenav" *ngIf="showTicketsList">
            <div class="top-line-bg">
                <span> Tickets </span>
                <span class="close-icon-subscribe" (click)="closeTicketsMenu()" [ngClass]="{'d-none' : activatedRoute?.snapshot?.queryParams?.user_id}">
                    <app-svg [icon]="'live-stream-close-icon-white'"></app-svg>
                </span>
            </div>
            <div class="p-15">
                <div class="tickets-div br-4 mb-10" *ngFor="let ticket of selectedStageTickets"
                    [ngStyle]="{'background-color': settingsData.bg_secondary_color || null, 'font-family': settingsData.font_family || null}">
                    <div class="row align-items-center no-gutters p-10">
                        <div class="col-6">
                            <div class="ticket_name font-data" [ngStyle]="{'color': settingsData.font_primary_color || null}">{{ticket.title}}</div>
                            <div class="amount font-data" [ngStyle]="{'color': settingsData.font_primary_color || null}">{{ticket?.price | currency: ticket?.currency}}</div>
                        </div>
                        <div class="col-6 text-right">
                            <button class="btn flat-primary-button" (click)="selectTicket(ticket)"
                                [ngStyle]="{'background-color': settingsData.bg_primary_color || null, 'color': settingsData.font_primary_color || null, 'font-family': settingsData.font_family || null}">select</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="isShownSideBar" class="rightsidenav" [ngStyle]="{'background-color': settingsData.form_bg_color || ''}">
            <div class="top-line-bg" [ngStyle]="{'background-color': settingsData.form_bg_color || ''}">
                <span> Subscribe </span>
                <span class="close-icon-subscribe" (click)="openSubscribeSideMenu()" [ngClass]="{'d-none' : activatedRoute?.snapshot?.queryParams?.user_id}">
                    <app-svg [icon]="'live-stream-close-icon-white'"></app-svg>
                </span>
                <app-subscription-list [planIds]="planIds" [creatorCurrency]="creatorCurrency"></app-subscription-list>
            </div>
        </div>

        <div *ngIf="isPaymentShow" class="rightsidenav" [ngStyle]="{'background-color': settingsData.form_bg_color || '', 'font-family': settingsData.font_family || ''}">
            <div class="top-line-bg" [ngStyle]="{'background-color': settingsData.form_bg_color || '', 'font-family': settingsData.font_family || ''}">
                <div class="row no-gutters align-items-center">
                    <div class="col-8">
                        <div class="d-inline-block" [ngStyle]="{'color': settingsData.form_font_secondary_color || '', 'font-size': settingsData.form_fs_main_title || ''}">Payment</div>
                    </div>
                    <div class="col-4 text-right">
                        <i class="fa fa-times-circle-o fs-24 pointer" [ngClass]="{'d-none' : activatedRoute?.snapshot?.queryParams?.user_id}"
                            [ngStyle]="{'color': settingsData.form_font_secondary_color || ''}" (click)="togglePaymentSideMenu()"></i>
                    </div>
                </div>
                <app-ic-media-payment (togglePaymentSideMenu)="togglePaymentSideMenu($event)" [settingsData]="settingsData"
                    [screenFrom]="'directive'" [tickets]="tickets" [paymentStreamInfo]="paymentStreamInfo" [performer_details]="performer_details">
                </app-ic-media-payment>
            </div>
        </div>
    </ng-container>

    <ng-template #notAvailable>
        <div class="vd-container vd-unavailable">
            <p>Album list not available for the {{ currentLocation?.country_name }}</p>
            <button type="button" class="vd-btn vd-btn-accent" (click)="goToGener()">Go To Home</button>
        </div>
    </ng-template>

    <app-vd-share-sheet *ngIf="shareTarget" [url]="shareUrl" [title]="shareTarget.stream_info?.stage || streamInfo.stream_video_title"
        [image]="shareImage" [anchor]="shareAnchor" (close)="closeShare()"></app-vd-share-sheet>

    <!-- Same condition and action as the classic floating Subscribe button; shown after scrolling -->
    <button type="button" class="vd-floating-subscribe" [class.is-shown]="showScroll" [attr.tabindex]="showScroll ? null : -1"
        [attr.aria-hidden]="showScroll ? null : true" *ngIf="actions.showFloatingSubscribe" (click)="doSubscribePayment(subEvents[0], true)">
        <app-vd-icon name="subscribe"></app-vd-icon> Subscribe</button>
</div>

<ng-template #albumInfo>
    <app-vd-info [title]="streamInfo.stream_video_title" [networkName]="networkName" [metaLine]="metaLine"
        [description]="description" [descriptionIsLong]="descriptionIsLong" [actions]="actions" [countdown]="countdown"
        (play)="playFromBanner(template)" (subscribeAlbum)="doSubscribePayment(streamInfo, true, 'album')"
        (buyAlbum)="openVideoAudioPayment(streamInfo, 'album')" (tip)="openTips()" (polls)="openPolls('Poll')"></app-vd-info>
</ng-template>

<ng-template #template>
    <div class="modal-body album-videos">
        <div [hidden]="!showAd" class="full-page-ad text-center">
            <div class="ablum-ads" data-closable>
                <div [innerHTML]="adVideo" class="ad bg-dark" *ngIf="showAd"></div>
                <div class="a mb-2" *ngIf="showTimer && showAd">
                    <a class="text-center mr-2 text-white text-decoration-none" [href]="selectedAdData" target="_blank">Learn more <app-vd-icon name="external"></app-vd-icon></a>
                </div>
                <button class="close-button" aria-label="Close alert" type="button" data-close *ngIf="showTimer && showAd" (click)="closeAdd()">
                    <span aria-hidden="true">{{secondsData}}<span class="ml-1"><i class="fa fa-step-forward"></i></span></span>
                </button>
            </div>
        </div>
        <div *ngIf="!showAd">
            <div class="album-video-title-box">
                <div class="album-video-title"> {{selectedVideo?.stage}} </div>
                <div class="report-btn album-video-title" *ngIf="!isPreviewUrl" (click)="reportFileData(selectedVideo, 'playerVideo')"
                    matTooltipPosition="below" matTooltip="Report Abuse"><i class="fa fa-flag"></i></div>
                <div class="close-btn album-video-title" (click)="close()"><app-svg [icon]="'live-stream-close-icon-white'"></app-svg></div>
            </div>
            <m3u8-video id="uploadedVideoPlayer" (timeupdate)="getCurrentTime($event)" [videoUrl]="videoURL"
                [openFrom]="'VideoAlbum'" [start_live_diff]="selectedStreamInfo?.start_live_diff" autoplay></m3u8-video>
        </div>
    </div>
</ng-template>
